export default __webpack_public_path__ + "static/media/minimal-look.220a180c.png";